export default function (input, settings) {



    settings = Object.assign({
        symbol: 'US$',
        decimalSeparator: '.',
        floatSeparator: false,
        precision: 2,
        thousands: "",//',',
        allowZero: false,
        allowNegative: false,
        showSymbol: false,
        symbolStay: false,
        defaultZero: true
    }, settings);


    const strCheck = '0123456789';

    function rawPennies(value) {
        let result = ''

        for (let i=0; i < value.length; i++) {
            if (strCheck.indexOf(value.charAt(i)) != -1) {
                result += value.charAt(i);
            }
        }
        
        let num = parseInt(result)
        result = isNaN(num) ? '0' : num.toString()

        return result
    }

    function maskValue(value) {


        value = value.replace(settings.symbol, '');

        
 
        
        let hasSeparator = value.indexOf(settings.decimalSeparator) != -1

        let precision = settings.floatSeparator ? Math.min(settings.precision, !hasSeparator ? 0 : value.length - value.indexOf(settings.decimalSeparator) - 1) : settings.precision

        var len = value.length;
        var a = '',
            t = '',
            neg = '';

        if (len != 0 && value.charAt(0) == '-') {
            value = value.replace('-', '');
            if (settings.allowNegative) {
                neg = '-';
            }
        }

        if (len == 0) {
            if (!settings.defaultZero) return t;
            t = '0.00';
        }

        for (var i = 0; i < len; i++) {
            if ((value.charAt(i) != '0') && (value.charAt(i) != settings.decimalSeparator)) 
            {
                break;
            }
        }

        for (; i < len; i++) {
            if (strCheck.indexOf(value.charAt(i)) != -1) {
                a += value.charAt(i);
            }
        }

        var n = parseFloat(a);
        
        n = isNaN(n) ? 0 : n / Math.pow(10, precision);


        t = n.toFixed(precision);

        i = precision == 0 ? 0 : 1;
        var p, d = (t = t.split('.'))[i].substr(0, precision);
        for (p = (t = t[0]).length;
            (p -= 3) >= 1;) {
            t = t.substr(0, p) + settings.thousands + t.substr(p);
        }

        return (precision > 0) ?
            setSymbol(neg + t + settings.decimalSeparator + d + Array((precision + 1) - d.length).join(0)) :
            setSymbol(neg + t + (hasSeparator ? settings.decimalSeparator : ''));


/*         let result;

        if (precision > 0) {

            if (settings.floatSeparator && !value.includes(settings.decimalSeparator)) {

                result = t
                
            } 
            else {
                result = t + settings.decimalSeparator + d + Array(precision + 1 - d.length).join(0)
            }   
        } 
        else {
            result = t
        }

        return setSymbol(neg + result) */
    }

    function setSymbol(v) {
        if (settings.showSymbol) {
            if (v.substr(0, settings.symbol.length) != settings.symbol) return settings.symbol + v;
        }
        return v;
    }


    function maskAndSetPosition(input, value, pos) {

        var originalLen = value.length;

        input.value = maskValue(value)


        var newLen = input.value.length;


        pos = pos - (originalLen - newLen);
        input.setSelectionRange(pos, pos);
        event.target.dispatchEvent(new Event('input'));
    }

    function onKeydown(e) {

        
        let start = e.target.selectionStart
        let end = e.target.selectionEnd
        let value = e.target.value




        if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(e.key)) {
            e.preventDefault();

        

            value = value.substring(0, start) + e.key + value.substring(end, value.length);

            if (rawPennies(value).length >= 9) {
                return false
            }

            maskAndSetPosition(e.target, value, start + 1)
            return false;
        } else if(settings.floatSeparator && settings.precision > 0 && e.key == settings.decimalSeparator && !value.includes(settings.decimalSeparator)) {
            e.preventDefault();


            value = value.substring(0, start) + e.key + value.substring(end, value.length);
/* 
            if (rawPennies(value).length >= 9) {
                return false
            } */

            maskAndSetPosition(e.target, value, start + 1)
            return false;

        } else if (e.code == 'Backspace') {
            e.preventDefault()
            if (start == end) {
                // Remove single character
                value = value.substring(0, start - 1) + value.substring(end, value.length);
                start = start - 1;
            } else {
                // Remove multiple characters
                value = value.substring(0, start) + value.substring(end, value.length);
            }
            maskAndSetPosition(e.target, value, start)
        } else if (e.code == 'Delete') {

            e.preventDefault()

            if (start == end) {
                // Remove single character
                value = value.substring(0, start) + value.substring(end + 1, value.length);


                /*      start = start + 1 */
            } else {
                //Remove multiple characters
                value = value.substring(0, start) + value.substring(end, value.length);
            }

            maskAndSetPosition(e.target, value, start)

        } else if (['Tab', 'ArrowLeft', 'ArrowRight', 'ArrowDown',
                'ArrowUp', 'Enter'
            ].includes(e.code)) {
            return true
        }

        e.preventDefault()


    }

    input.addEventListener('keydown', onKeydown)




}